import React, { useState, useMemo, useEffect } from "react";
import {
  imageBaseURLProduction,
  imageBaseURLFallback,
} from "../../services/api";

/**
 * Renders an img that tries production URL first; on error uses fallback URL.
 * Use for announcement (and other) images on both public and admin pages.
 */
const ImageWithFallback = ({
  path,
  alt = "",
  productionBase = imageBaseURLProduction,
  fallbackBase = imageBaseURLFallback,
  ...imgProps
}) => {
  const productionSrc = useMemo(
    () => (path ? `${productionBase.replace(/\/?$/, "/")}${path.replace(/^\//, "")}` : ""),
    [path, productionBase]
  );
  const fallbackSrc = useMemo(
    () => (path ? `${fallbackBase.replace(/\/?$/, "/")}${path.replace(/^\//, "")}` : ""),
    [path, fallbackBase]
  );

  const [src, setSrc] = useState(productionSrc);
  const [usedFallback, setUsedFallback] = useState(false);

  useEffect(() => {
    if (productionSrc) {
      setSrc(productionSrc);
      setUsedFallback(false);
    }
  }, [productionSrc]);

  const handleError = () => {
    if (!usedFallback && fallbackSrc && src === productionSrc) {
      setSrc(fallbackSrc);
      setUsedFallback(true);
    }
  };

  if (!path) return null;

  return (
    <img
      src={src}
      alt={alt}
      onError={handleError}
      {...imgProps}
    />
  );
};

export default ImageWithFallback;
